module.exports = __webpack_public_path__ + "static/media/android.4bc5ee77.png";